import { render, staticRenderFns } from "./AnimatedLink.vue?vue&type=template&id=0bffc1a4&"
import script from "./AnimatedLink.vue?vue&type=script&lang=js&"
export * from "./AnimatedLink.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports